import { useParams, useNavigate } from "react-router-dom";
import SiteText from "./SiteText";
import Styles from "./Styles";

const ServiceDescription = () => {
    const {id} = useParams();
    const navigate = useNavigate();
    
    const service = SiteText.Services.DataArray.find(s => s.id === id)

    return <div className="flex flex-col items-center justify-center m-8">
        <div className="text-5xl font-bold mb-8">
            {service.title}
        </div>
        <div className="flex max-md:flex-col items-center w-full">
            <div className="md:w-1/2 flex justify-end px-8">
                <img src={service.image} alt={"Image of " + service.title} />
            </div>
            <div className="md:w-2/5 max-md:pt-8 text-xl">
                {(service.descriptionLong === "" ? service.descriptionShort : service.descriptionLong)}
            </div>
        </div>
        <button className={Styles.Global.Button} onClick={() => navigate(SiteText.SitePaths.GetQuote)}>
            {SiteText.Global.GetQuote}
        </button>
    </div>
}

export default ServiceDescription;